import { formatPrice, perPageOf } from "../lib/plans";

export interface PriceTagProps {
  /** The price in whole pence. Formatted here so no screen formats money. */
  pence: number;
  /** Pages the price buys. Given, a small per-page line is drawn under the
   *  price; left out, there is no per-page line. The caller asks for it. */
  pages?: number;
  /** A note beside the price, for example "one off". */
  note?: string;
}

/** A price, from `plans.ts` and nowhere else. */
export function PriceTag({ pence, pages, note }: PriceTagProps) {
  return (
    <span className="pricetag">
      <span className="pricetag-line">
        <span className="pricetag-amount">{formatPrice(pence)}</span>
        {note ? <span className="pricetag-note">{note}</span> : null}
      </span>
      {pages ? (
        <span className="pricetag-each">{perPageOf({ pence, pages })}</span>
      ) : null}
    </span>
  );
}
